import { initialState } from '../../initialState';
import mainSocket from '../../../../shared/services/mainSocketClass';
import cache from '../models/cache-model';

import { getSportSlug } from '../../utils';

import {
    RACING_INIT,
    RACING_UPDATE_SCHEDULE,
    RACING_UPDATE_SCHEDULE_FROM_CACHE,
    RACING_INVALIDATE_SCHEDULE_CACHE,
    RACING_WS_EVENT_UPDATE,
    RACING_WS_EVENT_UNSUBSCRIBE,
} from '../actions/types';
import { WS_HANDLER_COMPONENT_NAME } from '../../constants';

/**
 * Schedule racing widget reducer
 * @param {Object} state the current state
 * @param {Object} action the action
 * @returns {Object} new state
 */
export default function scheduleReducer(state = initialState, action) {
    switch (action.type) {
        case RACING_INIT: {
            return {
                ...state,
                init: true,
                featured: action.data.featured,
                hasFeatured: action.data.featured,
                events: {
                    ...action.data.events,
                },
                display_order: [
                    ...action.data.display_order,
                ],
                default_event_id: action.data.default_event_id,
                events_extra_info: action.data.events_extra_info,
                tournaments_details: action.data.tournaments_details,
                sports_details: action.data.sports_details,
                timeform_events: action.data.timeform_events,
                racecard_urls: action.data.racecard_urls,
                selections: action.data.selections,
                timeform_selections: action.data.timeform_selections,
                type_code: action.data.type_code,
                widgetQuickLinks: action.data.widget_quick_links,
            };
        }
        case RACING_UPDATE_SCHEDULE: {
            const default_event_id = action.data.first_betable_event_id || action.data.first_event_id;
            const hasFeatured = action.data.unset_featured_tab ? false : state.hasFeatured;

            return {
                ...state,
                events: {
                    ...action.data.events,
                },
                display_order: [
                    ...action.data.display_order,
                ],
                featured: action.data.featured,
                default_event_id: default_event_id,
                timeform_events: action.data.timeform_events,
                events_extra_info: action.data.events_extra_info,
                tournaments_details: action.data.tournaments_details,
                racecard_urls: action.data.racecard_urls,
                hasFeatured,
                selected_event_id: null,
                selections: action.data.selections,
                timeform_selections: action.data.timeform_selections,
                type_code: action.data.type_code,
            };
        }
        case RACING_UPDATE_SCHEDULE_FROM_CACHE: {
            const sportSlug = getSportSlug(state.sports_details);
            const cachedEvents = cache.getCacheByType(sportSlug, action.raceType);
            const defaultEventId = cachedEvents.default_event_id;

            return {
                ...state,
                events: {
                    ...cachedEvents.events,
                },
                display_order: [
                    ...cachedEvents.display_order,
                ],
                default_event_id: defaultEventId,
                featured: cachedEvents.featured,
                events_extra_info: cachedEvents.events_extra_info,
                tournaments_details: cachedEvents.tournaments_details,
                racecard_urls: cachedEvents.racecard_urls,
                timeform_events: cachedEvents.timeform_events,
                selections: cachedEvents.selections[defaultEventId],
                timeform_selections: cachedEvents.timeform_selections[defaultEventId],
                type_code: cachedEvents.type_code[defaultEventId],
                selected_event_id: null,
            };
        }
        case RACING_INVALIDATE_SCHEDULE_CACHE: {
            const typeToInvalidate = action.raceType;
            const sportSlug = getSportSlug(state.sports_details);

            cache.deleteCache(sportSlug, typeToInvalidate);

            return state;
        }

        /**
         * @todo AM-2540 implement event handler removal - either in an unmount lifecycle method or directly by
         * calling removeHandlers() in wsInterface
         */
        case RACING_WS_EVENT_UPDATE: {
            mainSocket.subscribeForUpdates(action.wsEventsList, WS_HANDLER_COMPONENT_NAME);

            return state;
        }

        case RACING_WS_EVENT_UNSUBSCRIBE: {
            const typeToUnsubscribe = action.raceType;
            const sportSlug = getSportSlug(state.sports_details);
            const events = cache.getCacheByType(sportSlug, typeToUnsubscribe)?.events || {};
            const wsEventsList = Object.keys(events).map(event_id => ({ event_id }));
            mainSocket.unsubscribeForUpdates(wsEventsList);

            return state;
        }

        default:
            return state;
    }
}
